import React from 'react';
import PostPaymentContractProductsList from './PostPaymentContractProductsList';
import UpfrontContractProductsList from './UpfrontContractProductsList';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import ConfirmRenewalContractFormService from '../services/ConfirmRenewalContractFormService';

class ConfirmRenewalContractProductsListContainer extends React.Component {
  render() {
    const type = ConfirmRenewalContractFormService.form.getValue('type');
    const isV2 = ConfirmRenewalContractFormService.isV2;

    const currencyType =
      !ConfirmRenewalContractFormService.form.getValue('country') ||
      BRAZIL.includes(ConfirmRenewalContractFormService.form.getValue('country'))
        ? 'real'
        : 'dollar';

    if (type === 'UPFRONT' && isV2) {
      return (
        <UpfrontContractProductsList
          onDelete={ConfirmRenewalContractFormService.productsService.handleDelete}
          onEdit={ConfirmRenewalContractFormService.productsService.handleEdit}
          data={toJS(ConfirmRenewalContractFormService.productsService.contractProducts)}
          loading={ConfirmRenewalContractFormService.fetch.fetching}
          submitting={ConfirmRenewalContractFormService.submit.fetching}
          currencyType={currencyType}
          onToggleProduct={ConfirmRenewalContractFormService.productsService.handleToggleProduct}
        />
      );
    }

    return (
      <PostPaymentContractProductsList
        disabled={ConfirmRenewalContractFormService.fetch.fetching || ConfirmRenewalContractFormService.submit.fetching}
        onDelete={ConfirmRenewalContractFormService.productsService.handleDelete}
        onEdit={ConfirmRenewalContractFormService.productsService.handleEdit}
        data={toJS(ConfirmRenewalContractFormService.productsService.contractProducts)}
        loading={ConfirmRenewalContractFormService.fetch.fetching}
        submitting={ConfirmRenewalContractFormService.submit.fetching}
        currencyType={currencyType}
      />
    );
  }
}

export default observer(ConfirmRenewalContractProductsListContainer);
